// Package Imports
import React, { createContext, useContext, useEffect, useState } from 'react';
// Project Imports
import { TaskConfigContextType } from 'contexts/taskConfigContext/taskConfigContextType';
import { FilterValues } from 'pages/myTask/filters';
import routeName from 'core/common/routeName';

const TaskConfigContext = createContext<TaskConfigContextType>({
  taskConfigCurrent: 0,
  setTaskConfigCurrent() {
    throw new Error('setTaskConfigCurrent function is not implemented');
  },
});

export function useTaskConfigContext() {
  return useContext(TaskConfigContext);
}

interface FilterContextType {
  lastFilter: FilterValues | null;
  setLastFilter: (values: FilterValues | null) => void;
  returnPath: string;
  setReturnPath: (path: string) => void;
}

const FilterContext = createContext<FilterContextType>({
  lastFilter: null,
  setLastFilter: () => {},
  returnPath: `/${routeName.myTask}`,
  setReturnPath: () => {},
});

export function useFilterContext() {
  return useContext(FilterContext);
}

const TaskConfigProvider = ({ children }: { children: React.ReactNode }) => {
  const [taskConfigCurrent, setTaskConfigCurrent] = useState<any>(() => {
    const storedCurrent = localStorage.getItem('taskConfigCurrent');
    return Number(storedCurrent) || 0;
  });
  const [lastFilter, setLastFilter] = useState<FilterValues | null>(null);
  const [returnPath, setReturnPath] = useState<string>(`/${routeName.myTask}`);

  useEffect(() => {
    localStorage.setItem('taskConfigCurrent', taskConfigCurrent);
  }, [taskConfigCurrent]);

  return (
    <TaskConfigContext.Provider
      value={{ taskConfigCurrent, setTaskConfigCurrent }}
    >
      <FilterContext.Provider
        value={{ lastFilter, setLastFilter, returnPath, setReturnPath }}
      >
        {children}
      </FilterContext.Provider>
    </TaskConfigContext.Provider>
  );
};

export default TaskConfigProvider;
